mutation DeletePracticeRecordings($ids: [ID]!) {
  deletePracticeRecordings(ids: $ids) {
    ok
    errors
    deletedCount
  }
}
